export default {
  errorDefault: 'A apărut o eroare',
  unknown: 'Necunoscut',
};
